// Activity types from contract
//   1=register, 2=upgrade, 3=retopup,
//   4=sponsor, 5=level, 6=booster,
//   7=eliteRoyalty, 8=globalRoyalty, 9=heldClaim,
//   10=adminFreeReg, 12=proRoyalty
export const ACTIVITY_TYPES = {
  1:  { label: 'Registration',     icon: '+' },
  2:  { label: 'Package Upgrade',  icon: '↑' },
  3:  { label: 'Re-Topup',         icon: '↻' },
  4:  { label: 'Sponsor Income',   icon: '◆' },
  5:  { label: 'Level Income',     icon: '▤' },
  6:  { label: 'Booster Income',   icon: '⚡' },
  7:  { label: 'Elite Royalty',    icon: '★' },
  8:  { label: 'Global Royalty',   icon: '◈' },
  9:  { label: 'Held Claim',       icon: '◔' },
  10: { label: 'Admin Action',     icon: 'A' },
  12: { label: 'Pro Royalty',      icon: '♦' }
};

// Income types used in IncomePaid event / creditAndSplit
export const INCOME_TYPES = {
  1: 'Sponsor',
  2: 'Level',
  3: 'Booster',
  4: 'Elite Royalty',
  5: 'Pro Royalty',
  6: 'Global Royalty'
};

// Pool types used in distributePool / claim*
export const POOL_TYPES = {
  ELITE:  1,
  PRO:    2,
  GLOBAL: 3
};

// Default package prices (USD) — fallback before chain read
export const DEFAULT_PACKAGE_PRICES = [20, 40, 80, 150, 200, 250, 260];

export const PACKAGE_NAMES = [
  'Genesis',
  'Nova',
  'Pulsar',
  'Quasar',
  'Nebula',
  'Stellar',
  'Galaxy'
];

export const TOTAL_PACKAGES = 7;
export const MAX_MATRIX_LEVELS = 15;
export const MATRIX_TRACK_LEVELS = 5;
export const MATRIX_WIDTH = 2;
export const CEILING_MULTIPLIER = 4;
export const ADMIN_FEE_PERCENT = 5;

// Eligibility thresholds (mirrors Plans.sol)
export const ELITE_REQUIRED_PACKAGE = 4;
export const ELITE_REQUIRED_LEVEL = 4;
export const ELITE_REQUIRED_DIRECTS = 3;

export const PRO_REQUIRED_PACKAGE = 7;
export const PRO_REQUIRED_DIRECTS = 1;          // 1 direct with pkg 3+

export const GLOBAL_REQUIRED_PACKAGE = 7;
export const GLOBAL_REQUIRED_LEVEL = 5;
export const GLOBAL_REQUIRED_DIRECTS_IN_PKG = 3;
export const GLOBAL_REQUIRED_ELITE_DIRECTS = 3;

// Distribution split (% of GROSS upgrade)
export const SPONSOR_PERCENT = 50;
export const LEVEL_PERCENT = 30;
export const BOOSTER_PERCENT = 10;
export const POOL_PERCENT = 10;

// Pool share split (within the 10% pool reserve)
//   Elite Royalty:  3%
//   Pro Royalty:    3%
//   Global Royalty: 4%
//   --------------- = 10% total
export const ELITE_ROYALTY_PERCENT = 3;
export const PRO_ROYALTY_PERCENT = 3;
export const GLOBAL_ROYALTY_PERCENT = 4;

export const LEVEL_PERCENTS = [3, 3, 3, 3, 3, 3, 3, 2, 2, 1, 1, 1, 1, 0.5, 0.5];

// Net rate — wallet receives 95% per credit (5% fee → missing pool)
export const NET_RATE_PERCENT = 95;
